import { OriginReference } from "../../../../application/viewModels/CheckBaseViewModel";
import { ChecklistState } from "../../../../infrastructure/api/common/types";
import { Entity } from "../Entity";
import { SectionEntity } from "./SectionEntity";

export class ChecklistEntity extends Entity {
  public readonly serialNumber: string;
  public readonly title: string;
  public readonly id: number;
  public readonly specialFunctions: string;
  public readonly signed: boolean;
  public readonly state: ChecklistState;
  public readonly groups: SectionEntity[];
  public readonly createdBy: OriginReference | null = null;
  public readonly acceptedBy: OriginReference | null = null;

  protected constructor(
    uid: string,
    id: number,
    serialNumber: string,
    title: string,
    specialFunctions: string,
    signed: boolean,
    state: ChecklistState,
    groups: SectionEntity[],
    createdBy: OriginReference | null = null,
    acceptedBy: OriginReference | null = null,
  ) {
    super(uid);

    this.serialNumber = serialNumber;
    this.title = title;
    this.id = id;
    this.specialFunctions = specialFunctions;
    this.signed = signed;
    this.state = state;
    this.groups = groups;
    this.createdBy = createdBy;
    this.acceptedBy = acceptedBy;
  }

  public static new(
    id: number,
    serialNumber: string,
    title: string,
    specialFunctions: string,
    signed: boolean,
    state: ChecklistState,
    groups: SectionEntity[],
    createdBy: OriginReference | null = null,
    acceptedBy: OriginReference | null = null,
  ): ChecklistEntity {
    return new ChecklistEntity(
      "non-existing",
      id,
      serialNumber,
      title,
      specialFunctions,
      signed,
      state,
      groups,
      createdBy,
      acceptedBy,
    );
  }

  public static existing(
    id: number,
    uid: string,
    serialNumber: string,
    title: string,
    specialFunctions: string,
    signed: boolean,
    state: ChecklistState,
    groups: SectionEntity[],
    createdBy: OriginReference | null = null,
    acceptedBy: OriginReference | null = null,
  ): ChecklistEntity {
    return new ChecklistEntity(
      uid,
      id,
      serialNumber,
      title,
      specialFunctions,
      signed,
      state,
      groups,
      createdBy,
      acceptedBy,
    );
  }
}
